/** Carry each tab's local selection in the URL, including across reload and browser Back.
 * Only known query fields cross the tab boundary; no stored company data or redirect URLs. */
const pick = (source: URLSearchParams, keys: string[]) => {
  const out = new URLSearchParams();
  for (const key of keys) {
    const value = source.get(key);
    if (value) out.set(key, value);
  }
  return out;
};

export function overviewLinks(tab: 'dagen' | 'oppfolging', sp: URLSearchParams, base = '/hjem') {
  const day = pick(tab === 'dagen' ? sp : new URLSearchParams(sp.get('dag') ?? ''), [
    'd',
    'lag',
    'vis',
    'valgt',
  ]);
  const queue = pick(tab === 'oppfolging' ? sp : new URLSearchParams(sp.get('oppfolging') ?? ''), [
    'omrade',
    'valgt',
  ]);
  const dayContext = day.toString();
  const queueContext = queue.toString();
  if (queueContext) day.set('oppfolging', queueContext);
  if (dayContext) queue.set('dag', dayContext);
  return {
    day: `${base}${day.size ? `?${day}` : ''}`,
    queue: `/varsler${queue.size ? `?${queue}` : ''}`,
  };
}
